export const DEFAULT_TITLE = 'Searchlight';

export const PATH_TITLES = {
  '/orders': 'Orders'
};

export const BREAK_POINTS = {
  xl: 1920,
  lg: 1366,
  md: 980,
  sm: 736,
  xs: 0
};

export const STAGING = 'staging';
export const PRODUCTION = 'production';
export const DEVELOPMENT = !PRODUCTION && !STAGING;

export const TITLE_SEARCH_FEE = 34.50;
export const CC_SURCHARGE_FEE = 0.0195;